module.exports = __webpack_public_path__ + "img/s2P25.400adee5.png";